export const formStructure = [[{
  name: 'frota',
  label: 'Frota',
  placeholder: 'Digite para buscar a frota',
  component: 'SearchSelect',
  type: 'search',
  colProps: {
    md: 4
  },
  minSearchLength: 2,
  maxResults: 30
}, {
  name: 'motorista',
  label: 'Motorista',
  placeholder: 'Digite para buscar o motorista',
  component: 'SearchSelect',
  type: 'search',
  colProps: {
    md: 4
  },
  minSearchLength: 2,
  maxResults: 5
}, {
  name: 'gestor',
  label: 'Gestor',
  placeholder: 'Digite para buscar o gestor',
  component: 'SearchSelect',
  type: 'search',
  colProps: {
    md: 4
  },
  minSearchLength: 2,
  maxResults: 5
}], [{
  name: 'tipoModelo',
  label: 'Tipo Modelo',
  placeholder: 'Selecione o modelo',
  component: 'SearchSelect',
  type: 'search',
  colProps: {
    md: 6
  },
  minSearchLength: 2,
  maxResults: 50
}, {
  name: 'vazioem',
  label: 'Cidade vazio',
  placeholder: 'Digite aonde esta vazio',
  component: 'FormField',
  type: 'text',
  colProps: {
    md: 6
  },
  maxLength: 200
}], [{
  name: 'uf',
  label: 'UF',
  placeholder: 'Digite a UF',
  component: 'FormField',
  type: 'text',
  colProps: {
    md: 12
  },
  maxLength: 200
}], [{
  name: 'diasParados',
  label: 'Dias parados',
  placeholder: 'Dias parados',
  component: 'FormField',
  type: 'number',
  colProps: {
    md: 3
  },
  disabled: true
}, {
  name: 'diasAguardandoDescarga',
  label: 'Dias Aguardando Descarga',
  placeholder: 'Dias aguardando descarga',
  component: 'FormField',
  type: 'number',
  colProps: {
    md: 3
  },
  disabled: true
}, {
  name: 'dataAgendamento',
  label: 'Data Agendamento',
  placeholder: 'Data agendamento',
  component: 'DatePickers',
  type: 'date',
  colProps: {
    md: 3
  }
}, {
  name: 'DataDisponibilidade',
  label: 'Data de disponibilidade',
  placeholder: '',
  component: 'DatePickers',
  type: 'date',
  colProps: {
    md: 3
  }
}], [{
  name: 'responsavelComercial',
  label: 'Comercial',
  placeholder: 'Digite o comercial responsável',
  component: 'FormField',
  type: 'text',
  colProps: {
    md: 6
  },
  maxLength: 200
}, {
  name: 'destino',
  label: 'Destino',
  placeholder: 'Destino',
  component: 'FormField',
  type: 'text',
  colProps: {
    md: 6
  },
  maxLength: 2000
}], [{
  name: 'descargaPendente',
  label: 'Desc. Pendente',
  component: 'CheckBox',
  type: 'checkbox',
  colProps: {
    md: 'auto'
  }
}, {
  name: 'vazio',
  label: 'Vazio',
  component: 'CheckBox',
  type: 'checkbox',
  colProps: {
    md: 'auto'
  }
}, {
  name: 'negociacao',
  label: 'Negociação',
  component: 'CheckBox',
  type: 'checkbox',
  colProps: {
    md: 'auto'
  }
}, {
  name: 'coleta',
  label: 'Coleta',
  component: 'CheckBox',
  type: 'checkbox',
  colProps: {
    md: 'auto'
  }
}]];
export const formSections = initialValues => [{
  title: `Detalhes da frota ${initialValues.frota || ''}`,
  rows: [0, 1, 2, 3] // Renderiza as linhas 0, 1, 2 e 3 da formStructure

}, {
  title: 'RESPONSÁVEIS',
  rows: [4] // Renderiza a linha 4

}, {
  title: 'Informações Gerais',
  rows: [5] // Renderiza a linha 5

}]; // Função de validação do formulário

export const validateForm = values => {
  const errors = {}; // Validações específicas podem ser adicionadas aqui se necessário
  // Por exemplo, validação de datas, campos obrigatórios, etc.

  return errors;
};
